import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';
// @ts-ignore
import { parse } from 'properties-parser';
import intervalPlural from 'i18next-intervalplural-postprocessor';

i18n
  .use(XHR)
  .use(intervalPlural)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: false,
    saveMissing: false,
    fallbackLng: 'i18n',
    defaultNS: '',
    keySeparator: false, // we do not use keys in form messages.welcome
    lng: 'en-US',
    interpolation: {
      escapeValue: false // react already safes from xss
    },

    backend: {
      parse: (data: string): void => parse(data),
      loadPath: (language: string): string => {
        const i18nLanguage = language[0] !== 'i18n' ? `_${language}` : '';
        return `/i18n/i18n${i18nLanguage}.properties`;
      }
    }
  });

export default i18n;
